import axios from "axios";
import { EventBus, events } from "../../event-bus";
import store from "@/store";
import { allowedTemplatePatternByShopAndCountry } from "@/constants";

const getBearer = () => store.getters.teeInBlueBearer;
const getTeeinblueGrapgApiConfig = () => {
  return {
    method: "post",
    url: "https://graphql.teeinblue.com/v1/graphql",
    headers: {
      Authorization: "Bearer " + getBearer(),
    },
  };
};

const getTeeInBlueApiConfig = (url, method = "get") => {
  return {
    method: method,
    url: "https://portal-api.teeinblue.com/api" + url,
    headers: {
      Authorization: "Bearer " + getBearer(),
    },
  };
};

const getCustomizationDataFromTeeInBlue = async (customizationId) => {
  const response = await axios({
    ...getTeeInBlueApiConfig(`/customizations/${customizationId}`),
  }).catch((error) => console.log(error));
  return response.data;
};

const getTeeinblueOrder = async (orderName) => {
  // SINCE TEEINBLUE IS SERIALIZE CUSTOMIZATION IDS THIS IS NOW NECESSARY
  const searchQuery = orderName.split("#")[1];

  // Search Teeinblue by Order Name e.g. #1234-AQ
  const ordersRes = await axios({
    ...getTeeInBlueApiConfig(
      `/orders?by_teeinblue=1&cursor=&per_page=25&sort=created_at&sort_type=desc&s=${searchQuery}`
    ),
  }).catch(async (error) => {
    //Check if logged in
    if (error.response.status === 401) {
      const refreshResponse = await axios({
        ...getTeeInBlueApiConfig(`/token/refresh`, "post"),
      }).catch(async (e) => {
        if (e.response.status !== 200) {
          EventBus.$emit(events.SNACKBAR, {
            message: "Access Key von Teeinblue abgelaufen, bitte erneuern!",
            type: "error",
          });
          await store.commit("setShowDialogTeeInBlueBearer", true, null);
          throw new Error("access key expired!");
        }
      });
      await store.commit("setTeeInBlueBearer", refreshResponse.data.token);
    } else {
      EventBus.$emit(events.SNACKBAR, {
        message: "Something went wrong, contact Malte",
        type: "error",
      });
      EventBus.$emit(events.STOP_REMOVE_TEMPLATES);
    }
  });

  // TeeinBlueId
  const tibOrderId = ordersRes.data.data?.[0]?.id;

  let orderQuery = {
    operationName: "get",
    variables: {
      id: tibOrderId + "",
    },
    query:
      "query get($id: bigint!) {\n  orders_by_pk(id: $id) {\n    id\n    name\n    note\n    by_teeinblue\n    contact_email\n    created_at\n    cancelled_at\n    customer_id\n    email\n    customer {\n      id\n      by_teeinblue\n      created_at\n      currency\n      default_address\n      email\n      first_name\n      last_name\n      orders_count\n      phone\n      verified_email\n      __typename\n    }\n    instance_id\n    order_number\n    platform_linked_id\n    subtotal_price\n    total_price\n    total_price_usd\n    fulfillment_status\n    updated_at\n    shipping_address\n    fulfillment_shipping_method\n    billing_address\n    refunds\n    order_items(order_by: {id: desc}) {\n      created_at\n      by_teeinblue\n      fulfillable_quantity\n      fulfillment_service\n      fulfillment_status\n      grams\n      discount_allocations\n      customization_id\n      id\n      name\n      platform_linked_id\n      platform_product_id\n      platform_variant_id\n      platform_sku\n      price\n      quantity\n      requires_shipping\n      sku\n      tax_lines\n      title\n      taxable\n      total_discount\n      updated_at\n      cleaned_at\n      total_discount_set\n      variant_id\n      variant_inventory_management\n      variant_title\n      vendor\n      status\n      fulfillment_linked_id\n      fulfillment_linked_status\n      fulfillment_linked_reason\n      fulfillment_linked_created_at\n      fulfillment_linked_updated_at\n      deleted_at\n      properties\n      fulfiller {\n        id\n        fulfillment_linked_id\n        __typename\n      }\n      campaign {\n        id\n        name\n        __typename\n      }\n      variant {\n        fulfillment_linked_id\n        available\n        color\n        price\n        size\n        id\n        product_id\n        product {\n          fulfillment {\n            id\n            name\n            display_name\n            active\n            exportable\n            created_at\n            updated_at\n            user_fulfillments_aggregate {\n              aggregate {\n                count\n                __typename\n              }\n              __typename\n            }\n            __typename\n          }\n          __typename\n        }\n        __typename\n      }\n      order_item_artworks(order_by: {created_at: asc}) {\n        id\n        customization_id\n        order_item_id\n        url\n        thumbnail\n        width\n        height\n        artwork {\n          id\n          name\n          width\n          height\n          __typename\n        }\n        printarea {\n          id\n          name\n          display_name\n          width\n          height\n          __typename\n        }\n        customization {\n          campaign_id\n          platform_product_id\n          campaign {\n            id\n            name\n            __typename\n          }\n          platform_product {\n            id\n            name\n            __typename\n          }\n          __typename\n        }\n        key\n        processing_at\n        processed_at\n        updated_at\n        cancelled_at\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n}\n",
  };

  const orderRes = await axios({
    ...getTeeinblueGrapgApiConfig(),
    data: orderQuery,
  }).catch((error) => console.log(error));

  return orderRes.data.data;
};

const getCustomizationFromTeeInBlue = async (orderName, lineItemId) => {
  console.log(lineItemId);
  const tibOrder = await getTeeinblueOrder(orderName);
  console.log(tibOrder);
  const lineItem = tibOrder.orders_by_pk.order_items.find(
    (lineItem) => lineItem?.platform_linked_id === lineItemId?.toString()
  );
  console.log(lineItem);
  const customizationId = lineItem?.customization_id;

  let data = {
    operationName: "get",
    variables: {
      id: customizationId,
    },
    query:
      "query get($id: bigint!) {\n  customizations_by_pk(id: $id) {\n    id\n    campaign_id\n    data\n    __typename\n  }\n}\n",
  };

  const response = await axios({ ...getTeeinblueGrapgApiConfig(), data }).catch(
    (error) => console.log(error)
  );
  if (response.data.errors?.length) {
    EventBus.$emit(events.SNACKBAR, {
      message: "Access Key von Teeinblue abgelaufen, bitte erneuern!",
      type: "error",
    });
    EventBus.$emit(events.STOP_REMOVE_TEMPLATES);
    await store.commit("setShowDialogTeeInBlueBearer", true, null);
    throw new Error("access key expired!");
  }
  return response.data.data;
};

const rerenderCustomization = async (teeInBlueId) => {
  let config = {
    method: "post",
    url: `https://portal-api.teeinblue.com/api/order-item-artworks/${teeInBlueId}/design/generate`,
    headers: {
      Authorization: "Bearer " + getBearer(),
    },
  };

  axios(config)
    .then((response) => {})
    .catch((error) => {
      console.log(error);
    });
};

const disablePreviewAndSaveCustomization = async (
  customizationObject,
  teeInBlueId,
  shopId,
  countryCode
) => {
  if (!customizationObject || !teeInBlueId) {
    throw new Error("Failure");
  }
  const customizationId = customizationObject.customizations_by_pk.id;
  const customizationData = customizationObject.customizations_by_pk.data;
  let customizationIdsToDisable = {};

  // Check for each entry if it needs to be disabled
  // Everything except text and background (e.g. thumbnail of upload, preview) should be disabled by setting visibilty to false
  Object.entries(customizationData).forEach((entry) => {
    const [key, value] = entry;

    const allowedPattern =
      allowedTemplatePatternByShopAndCountry?.[shopId]?.[countryCode] ||
      /^[a-zA-Z\u00E4\u00FCa-åa-ö-w 0-9 -?!&$_.:]*$/;

    if (!allowedPattern.test(value?.toString())) {
      EventBus.$emit(events.SNACKBAR, {
        message: "Please check template for not allowed characters",
        type: "error",
      });
      throw new Error(value + " contains unallowed Characters!");
    }
    if (
      value &&
      typeof value === "string" &&
      (value.includes("cliparts") || value.includes("uploads")) &&
      !value.includes("420324")
    ) {
      customizationIdsToDisable = {
        ...customizationIdsToDisable,
        [`${key}-visibility`]: false,
      };
    }
  });

  // Data which needed to be post to teeinblue in order to disable preview
  let data = {
    operationName: "update",
    variables: {
      id: customizationId,
      objects: {
        data: {
          ...customizationData,
          ...customizationIdsToDisable,
        },
      },
    },
    query:
      "mutation update($id: bigint!, $objects: customizations_set_input!) {\n  update_customizations(where: {id: {_eq: $id}}, _set: $objects) {\n    returning {\n      id\n      __typename\n    }\n    __typename\n  }\n}\n",
  };

  axios({ ...getTeeinblueGrapgApiConfig(), data })
    .then((response) => {
      if (response.status === 200) {
        rerenderCustomization(teeInBlueId);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const removePreviewInTeeInBlue = async ({
  lineItemId,
  orderName,
  teeInBlueId,
  shopId,
  countryCode,
}) => {
  const customization = await getCustomizationFromTeeInBlue(
    orderName,
    lineItemId
  );
  await disablePreviewAndSaveCustomization(
    customization,
    teeInBlueId,
    shopId,
    countryCode
  );
};

export const getArtworkValuesFromTeeInBlue = async (customizationId) => {
  const customizationRes = await getCustomizationFromTeeInBlue("23496874");
  const customization = customizationRes.customizations_by_pk.data;
  const customizationData = await getCustomizationDataFromTeeInBlue("23496874");

  const layers = [];

  const isImage = (layer) => {
    return (
      layer.type === "clipart" &&
      layer.visible &&
      layer.required &&
      layer.show_in_cart
    );
  };

  customizationData.artworks[0].data[0].layers.forEach((layer) => {
    if (!!customization[layer.id]) {
      layers.push({
        value: customization?.[layer.id],
        layer: layer,
      });
    }
  });

  return layers;
};
